import Record from './base'
import { isPlainObject } from 'lodash'
export class Ticket extends Record {
  constructor(...props) {
    super(...props)
    //if (isPlainObject(props.ticket_holders)) {
    //  props.ticket_holders = props.ticket_holders[0]
    //}
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/ticket.js